module.exports = __webpack_public_path__ + "img/f.0c83693f.jpg";